import { defineStore } from 'pinia';
import axiosClient from '@/axiosClient';
import { API_ENDPOINTS } from '@/apiConfig';

let pendingStructuresRequest = null;

export const useStructuresStore = defineStore('structures', {
  state: () => ({
    structuresList: [],
    structuresLoading: false,
    structuresError: null,
    structuresLoaded: false,
  }),

  actions: {
    async fetchStructures({ force = false } = {}) {
      if (!force && this.structuresLoaded) return this.structuresList;
      if (pendingStructuresRequest) return pendingStructuresRequest;

      this.structuresLoading = true;
      this.structuresError = null;
      const request = (async () => {
        try {
          const response = await axiosClient.get(
            API_ENDPOINTS.fetchActiveEmployeeStructures,
          );
          if (!Array.isArray(response.data?.items)) {
            throw new Error('Invalid structures response.');
          }
          this.structuresList = response.data.items.map(structure => ({
            name: structure,
            code: structure,
          }));
          this.structuresLoaded = true;
          return this.structuresList;
        } catch (error) {
          this.structuresError = error.response?.data?.error
            || error.message
            || 'Failed to fetch structures.';
          this.structuresLoaded = false;
          throw error;
        } finally {
          this.structuresLoading = false;
        }
      })();

      pendingStructuresRequest = request;
      try {
        return await request;
      } finally {
        if (pendingStructuresRequest === request) pendingStructuresRequest = null;
      }
    },

    ensureStructures() {
      return this.fetchStructures();
    },

    clearStructures() {
      pendingStructuresRequest = null;
      this.$reset();
    },
  },
});
